import { Selector, createSelector } from "@ngxs/store";
import { ExerciseState, ExerciseStateModel } from "./exercise.state";
import { Exercise } from "../models/exercise.model";
import { CurrentExercise } from "../models/current-exercise.model";

export class ExerciseSelectors {

  @Selector([ExerciseState])
  static getExercises(state: ExerciseStateModel): Exercise[] {
    return state.exercises;
  }

  @Selector([ExerciseState])
  static getIsLoadingExercises(state: ExerciseStateModel) : boolean {
    return state.isLoadingExercises;
  }

  @Selector([ExerciseState])
  static getCurrentExercise(state: ExerciseStateModel): CurrentExercise {
    return state.currentExercise;
  }

  @Selector([ExerciseState])
  static getSelectedExercise(state: ExerciseStateModel): Exercise {
    return state.selectedExercise;
  }

  @Selector()
  static getExercise(exerciseId: number) {
    return createSelector([ExerciseState], (state) => {
      const exercise = state.exercise.exercises.find(l => l.exerciseId == exerciseId)
        return exercise;
    });
  }

  @Selector()
  static getExerciseByYearAndMonth(year: number, month: number) {
    return createSelector([ExerciseState], (state) => {
      const exercise = state.exercise.exercises.find(l => new Date(l.startDateExercise) <= new Date(year, month - 1, 1) && new Date(l.endDateExercise) >= new Date(year, month - 1, 0));
      return exercise;
    });
  }
}
